import { useEffect, useState, useRef } from "react";
import { Upload, Trash2, Copy } from "lucide-react";
import { toast } from "sonner";
import { api, mediaUrl } from "@/lib/api";

export default function MediaPage() {
  const [items, setItems] = useState([]);
  const [uploading, setUploading] = useState(false);
  const inputRef = useRef(null);

  const load = () => api.get("/admin/media").then((r) => setItems(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const upload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    const fd = new FormData();
    fd.append("file", file);
    try {
      await api.post("/admin/media/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      toast.success("Görsel yüklendi");
      load();
    } catch (err) {
      toast.error(err.response?.data?.detail || "Yükleme başarısız");
    } finally {
      setUploading(false);
      e.target.value = "";
    }
  };

  const remove = async (id) => {
    if (!window.confirm("Görsel silinsin mi?")) return;
    await api.delete(`/admin/media/${id}`);
    setItems((l) => l.filter((i) => i.id !== id));
    toast.success("Silindi");
  };

  const copyUrl = (url) => {
    navigator.clipboard.writeText(url);
    toast.success("URL kopyalandı — İçerik sekmesindeki görsel alanına yapıştırın");
  };

  return (
    <div data-testid="admin-media">
      <div className="flex items-center justify-between mb-8">
        <h1 className="text-2xl font-bold">Medya Kütüphanesi</h1>
        <button
          data-testid="upload-media-btn"
          onClick={() => inputRef.current?.click()}
          disabled={uploading}
          className="flex items-center gap-2 bg-[#8B0000] hover:bg-[#C1121F] px-5 py-2.5 text-xs tracking-wider uppercase transition-colors disabled:opacity-50"
        >
          <Upload size={14} /> {uploading ? "Yükleniyor..." : "Görsel Yükle"}
        </button>
        <input ref={inputRef} type="file" accept="image/*" onChange={upload} className="hidden" data-testid="media-file-input" />
      </div>
      <p className="text-sm text-[#525252] mb-6">Yüklenen görselin URL'sini kopyalayıp İçerik sekmesindeki (hero, marka, timeline) görsel alanlarına yapıştırın.</p>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        {items.map((m) => (
          <div key={m.id} className="border border-[#232323] bg-[#111111] group">
            <div className="h-40 overflow-hidden">
              <img src={mediaUrl(m.url)} alt={m.original} className="w-full h-full object-cover" loading="lazy" />
            </div>
            <div className="p-3 flex items-center justify-between gap-2">
              <p className="text-xs text-[#A3A3A3] truncate">{m.original}</p>
              <div className="flex gap-2 shrink-0">
                <button onClick={() => copyUrl(m.url)} title="URL kopyala" className="text-[#525252] hover:text-[#EDEDEA]"><Copy size={14} /></button>
                <button onClick={() => remove(m.id)} title="Sil" className="text-[#525252] hover:text-[#C1121F]"><Trash2 size={14} /></button>
              </div>
            </div>
          </div>
        ))}
        {items.length === 0 && <p className="text-[#525252] col-span-full">Henüz görsel yüklenmedi.</p>}
      </div>
    </div>
  );
}
